export var componentsLocales = {
  closeButtonAriaLabel: 'Закрыть модальное окно'
};